import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { videoShareUrl } from "@/lib/publicTutorials";

export const VideoShareButton = ({ item, idPrefix = "video", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const [fallback, setFallback] = useState(false);
  const id = `${idPrefix}-${item.audience}-${item.section}`;
  const url = videoShareUrl(item);
  const copy = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch { setFallback(true); }
  };
  return <>
    <Button type="button" variant="outline" size="sm" className={`w-28 shrink-0 ${className}`} onClick={copy}
      aria-label={`Copy link to ${item.title}`} data-testid={`${id}-copy-link`}>
      {copied ? <Check className="mr-1.5 h-4 w-4" /> : <Copy className="mr-1.5 h-4 w-4" />}
      <span role="status" data-testid={`${id}-copy-status`}>{copied ? "Copied" : "Copy link"}</span>
    </Button>
    <Dialog open={fallback} onOpenChange={setFallback}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-lg" data-testid={`${id}-share-dialog`} closeTestId={`${id}-share-close`}>
        <DialogHeader><DialogTitle data-testid={`${id}-share-title`}>Share {item.title}</DialogTitle>
          <DialogDescription data-testid={`${id}-share-description`}>Anyone with this link can watch. Select and copy the address below.</DialogDescription></DialogHeader>
        <Input readOnly value={url} aria-label="Video share link" onFocus={event => event.target.select()} onClick={event => event.currentTarget.select()} data-testid={`${id}-share-url`} />
      </DialogContent>
    </Dialog>
  </>;
};